const sanitizeUrl = (value) => {
    return value
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^a-z0-9-]/g, ""); 
};
  
export default sanitizeUrl;
  